import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, Checkbox, Form, Input, Radio } from "antd";
import { ESupportTicketQuestionType } from "@devowl-wp/api-real-commerce";
import { SupportFormNestedFieldsContainer } from "./nestedFieldsContainer.js";
import { __, _i } from "../../utils/i18n.js";
const SupportFormWpAccessDataField = ()=>{
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, curValues)=>prevValues.questionType !== curValues.questionType,
        children: (param)=>{
            let { getFieldValue } = param;
            return !!getFieldValue("questionType") && getFieldValue("questionType") === ESupportTicketQuestionType.ProblemWithProduct && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        label: __("Would you like to provide us with access to your WordPress admin area?"),
                        required: true,
                        shouldUpdate: (prevValues, nextValues)=>prevValues.provideAccessData !== nextValues.provideAccessData,
                        children: (param)=>{
                            let { getFieldValue } = param;
                            return /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Item, {
                                        noStyle: true,
                                        name: "provideAccessData",
                                        rules: [
                                            {
                                                required: true,
                                                message: __("Please choose one option!")
                                            }
                                        ],
                                        children: /*#__PURE__*/ _jsxs(Radio.Group, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Radio.Button, {
                                                    value: true,
                                                    children: __("Yes")
                                                }),
                                                /*#__PURE__*/ _jsx(Radio.Button, {
                                                    value: false,
                                                    children: __("No")
                                                })
                                            ]
                                        })
                                    }),
                                    getFieldValue("provideAccessData") === false && /*#__PURE__*/ _jsx(Alert, {
                                        style: {
                                            marginTop: 15
                                        },
                                        message: __("We can usually solve problems faster for you if we are allowed to look into your WordPress. Are you sure you don't want to give us access? Of course, we do not share your access data with others!"),
                                        type: "warning"
                                    })
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ _jsx(Form.Item, {
                        noStyle: true,
                        shouldUpdate: (prevValues, curValues)=>prevValues.provideAccessData !== curValues.provideAccessData,
                        children: (param)=>{
                            let { getFieldValue } = param;
                            return getFieldValue("provideAccessData") && /*#__PURE__*/ _jsxs(SupportFormNestedFieldsContainer, {
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Item, {
                                        name: "accessDataUrl",
                                        required: true,
                                        label: __("Link to admin sign-in"),
                                        rules: [
                                            {
                                                required: true,
                                                message: __("Please insert your login URL!")
                                            }
                                        ],
                                        children: /*#__PURE__*/ _jsx(Input, {
                                            placeholder: "https://example.com/wp-login.php"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Item, {
                                        name: "accessDataUsername",
                                        required: true,
                                        label: __("Username"),
                                        rules: [
                                            {
                                                required: true,
                                                message: __("Please insert the username!")
                                            }
                                        ],
                                        extra: _i(__("Create a new user in your WordPress ({{a}}read instructions{{/a}}) for the email address {{code}}support@devowl.io{{/code}}. The user must be administrator. If you use two-factor authentication, {{strong}}it must be disabled{{/strong}} for this user."), {
                                            a: /*#__PURE__*/ _jsx("a", {
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                href: __("https://devowl.io/knowledge-base/wordpress-user-create-and-delete/")
                                            }),
                                            code: /*#__PURE__*/ _jsx("code", {}),
                                            strong: /*#__PURE__*/ _jsx("strong", {})
                                        }),
                                        children: /*#__PURE__*/ _jsx(Input, {})
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Item, {
                                        name: "accessDataPassword",
                                        required: true,
                                        label: __("Password"),
                                        rules: [
                                            {
                                                required: true,
                                                message: __("Please insert the password!")
                                            }
                                        ],
                                        children: /*#__PURE__*/ _jsx(Input.Password, {})
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Item, {
                                        label: "",
                                        required: true,
                                        name: "accessDataDeleteAcknowledgment",
                                        valuePropName: "checked",
                                        rules: [
                                            {
                                                required: true,
                                                transform: (value)=>value || undefined,
                                                type: "boolean",
                                                message: __("In order to submit a support request, you must agree to this.")
                                            }
                                        ],
                                        children: /*#__PURE__*/ _jsx(Checkbox, {
                                            children: __("After the support case is closed, I will delete the user on my own.")
                                        })
                                    })
                                ]
                            });
                        }
                    })
                ]
            });
        }
    });
};
export { SupportFormWpAccessDataField };
